module.exports = __webpack_public_path__ + "img/Haefele_menu9.3fe5a60c.png";